import { connect } from "react-redux";

import CreateQuizSettings from "./CreateQuizSettings";

import { createQuizTest } from "../../QuizStudio/actions";

const mapStateToProps = ({ user }) => ({
  userError: user.error,
  currentUser: user.currentUser,
});

const mapDispatchToProps = {
  createQuizTest,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateQuizSettings);
